// Multipart upload helper for knowledge documents.
//
// Lives in its own module so the AIConfigPage doesn't dynamically
// import api.ts (which triggers a Vite chunking warning about mixed
// static + dynamic imports).

import { tenantContext } from "./tenant";

const API_BASE: string =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ??
  (typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1")
    ? "http://localhost:8000"
    : "https://solvait-aihr-production.up.railway.app");

let _tokenFn: (() => Promise<string | null>) | null = null;

export function setUploadTokenProvider(
  fn: (() => Promise<string | null>) | null,
): void {
  _tokenFn = fn;
}

export async function uploadKnowledgeViaFetch(
  legalEntityId: string,
  file: File,
  scope: string,
): Promise<void> {
  const headers: Record<string, string> = {};
  if (_tokenFn) {
    const token = await _tokenFn();
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }
  const slug = tenantContext().slug;
  if (slug) headers["X-Tenant-Slug"] = slug;

  const fd = new FormData();
  fd.append("file", file);
  fd.append("legal_entity_id", legalEntityId);
  fd.append("scope", scope);

  const r = await fetch(`${API_BASE}/api/ai-config/knowledge`, {
    method: "POST",
    headers,
    body: fd,
  });
  if (!r.ok) {
    let detail = r.statusText;
    try {
      const body = await r.json();
      if (body?.detail) detail = JSON.stringify(body.detail);
    } catch {
      // ignore
    }
    throw new Error(`Upload failed: ${detail}`);
  }
}
